import axios from "axios";

const TOKEN_KEY = "access";
const REFRESH_KEY = "refresh";
const USER_KEY = "user";

const login = async (username, password) => {
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/token/`, {
    username,
    password,
  });
  const { access, refresh } = res.data;
  localStorage.setItem(TOKEN_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);

  const userRes = await axios.get(
    `${process.env.REACT_APP_API_URL}/userinfo/`,
    {
      headers: { Authorization: `Bearer ${access}` },
    },
  );

  const userData = {
    username: userRes.data.username,
    groups: userRes.data.groups,
  };
  localStorage.setItem(USER_KEY, JSON.stringify(userData));
  return userData;
};

const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
};

const getCurrentUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

const getAccessToken = () => localStorage.getItem(TOKEN_KEY);
const getRefreshToken = () => localStorage.getItem(REFRESH_KEY);

const saveTokens = ({ access, refresh }) => {
  localStorage.setItem(TOKEN_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);
};

const refreshAccessToken = async () => {
  const refresh = getRefreshToken();
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/token/refresh/`,
      {
        refresh,
      },
    );
    saveTokens(res.data);
    return res.data.access;
  } catch {
    logout();
    return null;
  }
};

const getTokenExpiry = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000;
  } catch {
    return null;
  }
};

const setupAutoLogout = () => {
  const expiry = getTokenExpiry(getRefreshToken());
  if (!expiry) return;
  const timeout = expiry - Date.now();
  if (timeout > 0) {
    setTimeout(() => {
      logout();
      alert("Session expired. Please log in again.");
      window.location.reload();
    }, timeout);
  } else {
    logout();
    window.location.reload();
  }
};

export {
  login,
  logout,
  getCurrentUser,
  getAccessToken,
  refreshAccessToken,
  setupAutoLogout,
};
